<template>
    <div class="loading-wrap">
        <div class="loading-img-wrap">
            <img src="@assets/images/live-logo.gif" class="loading-img" />
        </div>
    </div>
</template>
<script>
export default {
    name: "PageLoading",
    props: {},
    data: function() {
        return {};
    },
    methods: {}
};
</script>
<style lang="scss" scoped>
.loading-wrap {
    inset: 0;
    z-index: 99;
    display: flex;
    position: fixed;
    background: #fff;
    align-items: center;
    justify-content: center;

    .loading-img {
        width: 50vw;
    }
}
</style>